import { createRouter, createWebHashHistory } from 'vue-router';

/*
 * Define router to each view
 */

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/MainView.vue'),
    },
    /*
    {
        path: '/account-registry',
        name: 'SignUp',
        component:  () => import('../components/auth/AccountRegistrationForm.vue')
    },
    
    {
        path: '/login',
        name: 'Login',
        component:  () => import('../components/auth/Login.vue')
    },
    */
    {
        path: '/profile',
        name: 'Profile',
        component: () => import('../components/usr/Profile.vue'),
    },
    {
        path: '/update-profile-info',
        name: 'UpdateProfileInfo',
        component: () => import('../components/usr/ProfileUpdateForm.vue'),
    },
    {
        path: '/update-account-password',
        name: 'UpdateAccountPassword',
        component: () => import('../components/usr/PasswordUpdateForm.vue'),
    },
    {
        path: '/update-account-email',
        name: 'UpdateAccountEmail',
        component: () => import('../components/usr/AccountEmailUpdateForm.vue'),
    },
    {
        path: '/marketplace',
        name: 'Marketplace',
        component: () => import('../views/MarketplaceView.vue'),
    },
    {
        path: '/store/:supplierRefId',
        name: 'Store',
        component: () => import('../views/StoreView.vue'),
    },
    {
        path: '/products',
        name: 'Products',
        component: () => import('../views/StoreView.vue'),
    },
    {
        path: '/product-details/:supplierRefId/:productRefId',
        name: 'Product Details',
        component: () => import('../views/ProductInfo.vue'),
    },
    {
        path: '/inquiry',
        name: 'Inquiry',
        component: () => import('../views/contact/Inquiry.vue'),
    },
    {
        path: '/cart',
        name: 'CartInfo',
        component: () => import('../views/Cart.vue'),
    },
    {
        path: '/order-init',
        name: 'OrderInit',
        component: () => import('../views/OrderInit2.vue'),
    },
    /*
    {
        path: '/order',
        name: 'Order',
        component: () => import('../views/Order.vue'),
    },
    */
    {
        path: '/order',
        name: 'Order',
        component: () => import('../views/OrderToCheckout.vue'),
    },
    {
        path: '/my-orders',
        name: 'My Orders',
        component: () => import('../views/OrderHistory.vue'),
    },
    {
        path: '/my-coupons',
        name: 'My Coupons',
        component: () => import('../views/MyCoupons.vue'),
    },
    {
        path: '/checkout/:supplierRefId/:orderId',
        name: 'Checkout',
        component: () => import('../views/Checkout.vue'),
    },
    {
        path: '/terms',
        name: 'Terms',
        component: () => import('../views/legal/Terms.vue'),
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: () => import('../views/legal/Privacy.vue'),
    },
    /*
  {
    path: '/contact/:supplierRefId',
    name: 'StoreContact',    
    component: () => import('../views/StoreContact.vue')
  },*/
    {
        path: '/contact',
        name: 'StoreContact',
        component: () => import('../views/StoreContact.vue'),
    },
    {
        path: '/feedback',
        name: 'FeedbackForms',
        component: () => import('../views/feedback/FeedbackForm.vue'),
    },
    {
        path: '/feedback/consulting',
        name: 'ConsultingFeedbackForm',
        component: () => import('../views/feedback/ConsultingFeedbackForm.vue'),
    },
    {
        path: '/feedback/sales',
        name: 'SalesFeedbackForm',
        component: () => import('../views/feedback/SalesFeedbackForm.vue'),
    },
    {
        path: '/feedback/installation',
        name: 'InstallationFeedbackForm',
        component: () => import('../views/feedback/InstallationFeedbackForm.vue'),
    },
    {
        path: '/search',
        name: 'SearchProducts',
        component: () => import('../views/SearchProducts.vue'),
    },

    {
        path: '/careers',
        name: 'Careers',
        component: () => import('../views/job/JobListings.vue'),
    },
    {
        path: '/careers/:code',
        name: 'Job Details',
        component: () => import('../views/job/JobDetails.vue'),
    },
    {
        path: '/change-store/:fromSupplierRefId/:toSupplierRefId',
        name: 'ChangeStore',
        component: () => import('../views/StoreChangeView.vue'),
    },
    {
        path: '/shopping-privileges',
        name: 'ShoppingPrivileges',
        component: () => import('../views/info/ShoppingPrivilegesView.vue'),
    },
    {
        path: '/promo-deals',
        name: 'PromoDeals',
        component: () => import('../views/info/PromotionsAndDeals.vue'),
    },
    {
        path: '/sustainability',
        name: 'SustainabilityInfo',
        component: () => import('../views/info/SustainabilityInfoView.vue'),
    },
    {
        path: '/sustainable-projects',
        name: 'SustainableProjects',
        component: () => import('../views/info/SustainableProjects.vue'),
    },
    {
        path: '/promo-products',
        name: 'PromoProducts',
        component: () => import('../components/PromoProducts.vue'),
    },
    {
        path: '/deal-products',
        name: 'DealProducts',
        component: () => import('../components/DealProducts.vue'),
    },
    {
        path: '/topics',
        name: 'Topics',
        component: () => import('../views/info/TopicsView.vue'),
    },
    {
        path: '/about-us',
        name: 'AboutUs',
        component: () => import('../views/info/AboutUs.vue'),
    },
    {
        path: '/corporate-sales',
        name: 'CorporateSales',
        component: () => import('../views/info/CorporateSales.vue'),
    },
    {
        path: '/digital-gift',
        name: 'DigitalGift',
        component: () => import('../views/info/DigitalGift.vue'),
    },
    {
        path: '/search-coupon',
        name: 'Search Coupon',
        component: () => import('../views/SearchCouponView.vue'),
    },
    {
        path: '/installation-services',
        name: 'InstallationServices',
        component: () => import('../views/info/InstallationServices.vue'),
    },
    {
        path: '/content',
        name: 'Explore',
        component: () => import('../views/ContentExplorerView.vue'),
    },
    {
        path: '/pmt-cod',
        name: 'CodPaymentOrder',
        component: () => import('../components/payment/cod/CodPaymentForm.vue'),
    },
    {
        path: '/pmt-mpu',
        name: 'MpuPaymentOrder',
        component: () => import('../components/payment/mpu/MpuPaymentForm.vue'),
    },
    {
        path: '/pmt-kpay-qr',
        name: 'KpayQrPaymentOrder',
        component: () => import('../components/payment/kbz/KbzQrScanPaymentForm.vue'),
    },
    {
        path: '/pmt-cbpay-qr',
        name: 'CBPayQrPaymentOrder',
        component: () => import('../components/payment/cb/CBQRScanPaymentForm.vue'),
    },
    {
        path: '/ess-inq',
        name: 'EssInquiry',
        component: () => import('../views/biznex/EssInquiryFormView.vue'),
    },
    {
        path: '/engagement',
        name: 'LeadCreation',
        component: () => import('../views/lead_creation/LeadCreationForm.vue'),
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior() {
        return { left: 0, top: 0 };
    },
});

export default router;
